import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
// import PlansOptions from "../../shared/components/payment/plansOptions";
import PlansOptions from "../../components/payment/plansOptions";
import SelectPlan from "../../components/payment/selectPlan";
import {
  useGetCurrentSubscriptionQuery,
  useLazyGetCurrentSubscriptionQuery,
} from "../../redux/slices/paymentApiSlice";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { H1Header } from "../../components";
const Pricing = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [newSubscription, setNewSubscription] = useState(null);
  const [
    getSubscription,
    {
      data: currentSubscription,
      isLoading: currentSubLoading,
      refetch: currentSubRefetch,
    },
  ] = useLazyGetCurrentSubscriptionQuery();
  const handleNewSubscriptionSelection = async (new_sub) => {
    setNewSubscription(new_sub);
    setOpen(true);
  };
  const userInfo = useSelector((state) => state?.auth).userInfo;
  useEffect(() => {
    if (userInfo.plan != null) {
      getSubscription();
    }
  }, []);
  return (
    <div className="px-2 pl-6 pr-6">
      <Helmet>
        <title>{t("pricing-and-plans", "Tarifs et formules")} | BotBlogR</title>
        <meta
          name="description"
          content="Vision générale de votre compte et de vos activités."
        />
      </Helmet>

      {/* {userInfo?.payment_status === "active" && ( */}
        {/* <div className="flex flex-col md:flex-row items-center justify-center lg:justify-end">
          <button
            onClick={() => {
              navigate("/token-packs");
            }}
            className="hover:bg-blue-200 *: bg-blue-100 text-white disabled:bg-slate-200
         disabled:text-slate-400 font-light px-5 py-[6px] rounded flex items-center"
          >
            {t("SEO-token-packs", "SEO Token Packs")}
          </button>
        </div> */}
      {/* )} */}
      <div className="py-3 flex flex-col w-full justify-center items-center">
        <H1Header title={t("Plans", "Tarifs")} />
      </div>
      <PlansOptions
        isPage={true}
        selectSubscription={handleNewSubscriptionSelection}
        refetchCurrentSub={getSubscription}
      />

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        className="relative z-[999]"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-[999] w-screen overflow-y-auto bg-black/50">
          <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-4 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in max-sm:10/12 md:w-8/12 lg:w-6/12 sm:p-8 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <button
                className="absolute top-2 right-3 text-gray-400 hover:text-gray-600 focus:outline-none text-2xl"
                onClick={() => setOpen(false)}
              >
                <span className="sr-only">Close</span>
                &#10005;
              </button>

              <div className="">
                <DialogTitle
                  as="h3"
                  className="text-xl font-semibold leading-6 text-gray-900"
                >
                  Confirmer le changement d'abonnement
                </DialogTitle>

                <SelectPlan
                  newPlan={newSubscription}
                  currentSubscription={currentSubscription}
                  refetchCurrentSub={currentSubRefetch}
                  returnToOptions={() => setOpen(false)}
                />
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default Pricing;
